import {
    HttpRequest,
    HttpInterceptorFn,
    HttpHandlerFn,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { NotificationService } from '@hs/ui-core-notifications';
import { Observable, catchError, throwError } from 'rxjs';

export const httpErrorInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const notificationsService = inject(NotificationService);
    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            const e = error as { name?: string, message?: string, error?: { message: string } };
            const errorMessage = e.error?.message ?? e.message ?? 'An unknown error occurred';
            if (error.name === 'HttpErrorResponse' && !shouldCustomFormatErrorMessage(errorMessage)) {
                notificationsService.notifyOfError(errorMessage);
            }
            return throwError(() => error);
        }),
    );
};

function shouldCustomFormatErrorMessage(message: string): boolean {
    const customFormattedMessages = ['Circular dependency detected'];
    return customFormattedMessages.some((customMessage) => message.includes(customMessage));
}
